module.exports = __webpack_public_path__ + "static/img/moveDown.eb967e2d.png";